<template>
    <div>
        <base-page-header :breadcrumb="breadcrumb" :title="$t('environmental-management.documentation.title')">
            <template #header-actions v-if="userState.isAdminSILiAmb">
                <div  class="select-entity">
                    <v-select
                        :items="entities.map(el => ({text: el.name, value: +el.value}))"
                        v-model="selectEntity"
                        @change="getFiles(selectEntity)"
                        filled
                        :label="$t('environmental-management.documentation.entity-label')"
                        :menu-props="{ top: false, offsetY: true }"
                    ></v-select>
                </div>
            </template>
        </base-page-header>

        <v-row>
            <v-col cols="12" sm="12">
                <div class="row-tabs">
                    <v-tabs
                        v-model="tab"
                        background-color="transparent"
                        color="basil"
                        grow
                        >
                            <v-tab
                                v-for="tabtitle in tabsTitle"
                                :key="tabtitle.title"
                            >
                                {{ tabtitle.title }}
                            </v-tab>
                    </v-tabs>

                    <v-tabs-items v-model="tab">
                        <v-tab-item
                            v-for="item in tabsTitle"
                            :key="item.title"
                        >
                            <v-card
                            flat
                            >
                                <div v-for="card in item.archives" :key="card.title"  class="card-text-bg">
                                    <v-card-text>
                                        <v-row  class="mb-0">
                                            <v-col cols="12" sm="6" class="pb-0">
                                                <h3 class="title-card">{{ card.title }}</h3>
                                            </v-col>
                                            <v-col cols="12" sm="6" class="text-center text-md-right">
                                                <a class="button-upload" @click="uploadFile(item.type,card.type, card.title)">
                                                    <img src="/images/_SVGs/environmental/upload.svg" class="mr-3" alt="PDF" width="20" height="20"/>{{$t('environmental-management.documentation.charge-file')}}
                                                </a>
                                            </v-col>
                                        </v-row>

                                        <div class="row-files">
                                            <p class="card-link-pdf" v-for="(pdf) in card.files" :key="pdf.key">
                                                <a :href="pdf.url" download target="_blank" >
                                                    <img src="/images/_SVGs/bo/historico.svg" class="mr-3" alt="PDF" width="25" height="25"/>
                                                    {{pdf.titleFile}}
                                                </a>
                                                <a class="img-remove" @click="afterRemoveFile(pdf.type, pdf.subType, pdf.titleFile)">
                                                    <img src="/images/_SVGs/environmental/remove.svg" class="ml-3" onload="SVGInject(this)" alt="Remover PDF" width="25" height="25"/>
                                                </a>
                                            </p>
                                        </div>
                                    </v-card-text>
                                </div>
                            </v-card>
                        </v-tab-item>
                    </v-tabs-items>
                </div>
            </v-col>
        </v-row>

        <base-modal v-model="modalUpload.show" :title="modalUpload.title" modal-width="560px" >
            <template v-slot:modal-close>
                <div @click="modalUpload.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>

                <InputFile
                    v-if="!clearUpload"
                    accept=".pdf, .csv,.docx, .xlsx"

                    @loadUpload ="loadUploadEmit"
                />
                <p class="text-center">
                    <small>{{$t('environmental-management.documentation.input-subtitle')}}</small>
                </p>
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="closeModal">
                        {{$t('cancel')}}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text :disabled="!fileUpload" @click="afterSaveUpload">
                        {{$t('environmental-management.documentation.charge')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal v-model="modalDuplicate.show" :title="$t('heads-up')" modal-width="560px" >
            <template v-slot:modal-close>
                <div @click="modalDuplicate.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                {{$t('environmental-management.documentation.modal-duplicate.msg')}}
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="closeModal">
                        {{$t('no')}}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text :disabled="!fileUpload" @click="saveUpload">
                        {{$t('yes')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal v-model="modalRemove.show" :title="$t('heads-up')" modal-width="560px" >
            <template v-slot:modal-close>
                <div @click="modalRemove.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                {{$t('environmental-management.documentation.modal-remove.msg')}}
            </template>

            <template v-slot:modal-actions>
                <div class="mr-2">
                    <v-btn class="danger-button" text @click="modalRemove.show = false">
                        {{$t('no')}}
                    </v-btn>
                </div>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="removeFile(modalRemove.type, modalRemove.subType, modalRemove.name)">
                        {{$t('yes')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>

        <base-modal v-model="modalAlert.show" :title="$t('heads-up')" modal-width="560px" >
            <template v-slot:modal-close>
                <div @click="modalAlert.show = false">
                    <img src="/images/_SVGs/environmental/fechar.svg" onload="SVGInject(this)" width="20" height="20" />
                </div>
            </template>

            <template v-slot:modal-body>
                {{modalAlert.msg}}
            </template>

            <template v-slot:modal-actions>
                <div class="ml-2">
                    <v-btn class="primary-button" text @click="modalAlert.show = false">
                        {{$t('ok')}}
                    </v-btn>
                </div>
            </template>
        </base-modal>
    </div>
</template>

<script>
import { GetDocumentationFiles, DeleteDocumentationFile, UploadDocumentationFile, GetDocumentationEntities } from '@services/b2b/environmental-management/DocumentationService';

import InputFile from '@components/b2b/widgets/InputFile.vue';
import BaseModal from "@components/shared/widgets/BaseModal.vue";
import BasePageHeader from "@components/shared/widgets/pages-header/BasePageHeader.vue";
    export default {
        components:{
            BasePageHeader,
            BaseModal,
            InputFile
        },
        data(){
            return{
                breadcrumb: [
                    {
                        title: this.$t('environmental-management.title'),
                        routerLinkName: 'environmentalManagement'
                    },
                    {
                        title: this.$t('environmental-management.documentation.title'),
                    }
                ],

                files: [],

                entities: [{
                    "name": '',
                    "value": 0
                }],

                tab: null,

                tabsTitle: [
                    {
                        title: this.$t('environmental-management.documentation.tabs-title.tab1.title'),
                        type: 'general',
                        archives:[
                            {
                                id:1,
                                title: this.$t('environmental-management.documentation.tabs-title.tab1.archives.title1'),
                                type: 'forms',

                                files:[]
                            },
                            {
                                id:2,
                                title: this.$t('environmental-management.documentation.tabs-title.tab1.archives.title2'),
                                type: 'legislation',
                                files:[]
                            },
                            {
                                id:3,
                                title: this.$t('environmental-management.documentation.tabs-title.tab1.archives.title3'),
                                type: 'others',
                                files:[]
                            }
                        ]
                    },
                    {
                        title: this.$t('environmental-management.documentation.tabs-title.tab2.title'),
                        type: 'mirr',
                        archives:[
                            {
                                id:3,
                                title: this.$t('environmental-management.documentation.tabs-title.tab2.archives.title'),
                                type: 'others',
                                files:[]
                            }
                        ]
                    },
                    {
                        title: this.$t('environmental-management.documentation.tabs-title.tab3.title'),
                        type: 'protocols',
                        archives:[
                            {
                                id:1,
                                title: this.$t('environmental-management.documentation.tabs-title.tab3.archives.title1'),
                                type: 'contracts',
                                files:[]
                            },
                            {
                                id:2,
                                title: this.$t('environmental-management.documentation.tabs-title.tab3.archives.title2'),
                                type: 'others',
                                files:[]
                            }
                        ]
                    },
                    {
                        title: this.$t('environmental-management.documentation.tabs-title.tab4.title'),
                        type: 'gaseous_fluorinated',
                        archives:[
                            {
                                id:1,
                                title: this.$t('environmental-management.documentation.tabs-title.tab4.archives.title1'),
                                type: 'forms',
                                files:[]
                            },
                            {
                                id:2,
                                title: this.$t('environmental-management.documentation.tabs-title.tab4.archives.title2'),
                                type: 'history',
                                files:[]
                            }
                        ]
                    },
                    {
                        title: this.$t('environmental-management.documentation.tabs-title.tab5.title'),
                        type: 'gaseous_emissions',
                        archives:[
                            {
                                id:1,
                                title: this.$t('environmental-management.documentation.tabs-title.tab5.archives.title1'),
                                type: 'forms',
                                files:[]
                            },
                            {
                                id:2,
                                title: this.$t('environmental-management.documentation.tabs-title.tab5.archives.title2'),
                                type: 'history',
                                files:[]
                            }
                        ]
                    }
                ],

                tabsTitleOriginal: [
                    {
                        title: this.$t('environmental-management.documentation.tabs-title-original.tab1.title'),
                        type: 'general',
                        archives:[
                            {
                                id:1,
                                title: this.$t('environmental-management.documentation.tabs-title-original.tab1.archives.title1'),
                                type: 'forms',
                                files:[]
                            },
                            {
                                id:2,
                                title: this.$t('environmental-management.documentation.tabs-title-original.tab1.archives.title2'),
                                type: 'legislation',
                                files:[]
                            },
                            {
                                id:3,
                                title: this.$t('environmental-management.documentation.tabs-title-original.tab1.archives.title3'),
                                type: 'others',
                                files:[]
                            }
                        ]
                    },
                    {
                        title: this.$t('environmental-management.documentation.tabs-title-original.tab2.title'),
                        type: 'mirr',
                        archives:[
                            {
                                id:3,
                                title: this.$t('environmental-management.documentation.tabs-title-original.tab2.archives.title'),
                                type: 'others',
                                files:[]
                            }
                        ]
                    },
                    {
                        title: this.$t('environmental-management.documentation.tabs-title-original.tab3.title'),
                        type: 'protocols',
                        archives:[
                            {
                                id:1,
                                title: this.$t('environmental-management.documentation.tabs-title-original.tab3.archives.title1'),
                                type: 'contracts',
                                files:[]
                            },
                            {
                                id:2,
                                title: this.$t('environmental-management.documentation.tabs-title-original.tab3.archives.title2'),
                                type: 'others',
                                files:[]
                            }
                        ]
                    },
                    {
                        title: this.$t('environmental-management.documentation.tabs-title-original.tab4.title'),
                        type: 'gaseous_fluorinated',
                        archives:[
                            {
                                id:1,
                                title: this.$t('environmental-management.documentation.tabs-title-original.tab4.archives.title1'),
                                type: 'forms',
                                files:[]
                            },
                            {
                                id:2,
                                title: this.$t('environmental-management.documentation.tabs-title-original.tab4.archives.title2'),
                                type: 'history',
                                files:[]
                            }
                        ]
                    },
                    {
                        title: this.$t('environmental-management.documentation.tabs-title-original.tab5.title'),
                        type: 'gaseous_emissions',
                        archives:[
                            {
                                id:1,
                                title: this.$t('environmental-management.documentation.tabs-title-original.tab5.archives.title1'),
                                type: 'forms',
                                files:[]
                            },
                            {
                                id:2,
                                title: this.$t('environmental-management.documentation.tabs-title-original.tab5.archives.title2'),
                                type: 'history',
                                files:[]
                            }
                        ]
                    }
                ],

                modalUpload:{
                    show: false,
                    id_upload: null,
                    title: '',
                    type: null,
                    subType: null
                },
                modalDuplicate:{
                    show:false,
                },
                modalAlert:{
                    show:false,
                    msg: ''
                },
                modalRemove:{
                    show:false,
                    type: '',
                    subType: '',
                    name: ''
                },
                selectEntity: null,
                fileUpload: null,
                clearUpload: false,
                isFileExist: false
            }
        },

        computed:{
            userState() {
                return this.$store.getters['auth/getState'];
            },
        },

        methods:{
            uploadFile(type, subType,title){
                this.clearUpload = false;
                this.modalUpload.title = title;
                this.modalUpload.id = 1,
                this.modalUpload.show = true

                this.modalUpload.type= type,
                this.modalUpload.subType= subType


            },
            afterSaveUpload(){
                let isFileExist = false;
                this.tabsTitle.filter(el => {
                    if(el.type == this.modalUpload.type){
                        el.archives.filter(el2 => {
                            if(el2.type == this.modalUpload.subType){
                                el2.files.filter(file => {
                                    if(file.titleFile == this.fileUpload.name){
                                        isFileExist = true;
                                    }
                                })
                            }
                        })
                    }
                })

                this.isFileExist = isFileExist;
                if(isFileExist){
                    this.modalUpload.show = false;
                    this.modalDuplicate.show = true;
                }else{
                    this.saveUpload()
                }
            },
            saveUpload(){

                this.$store.commit('loadings/setStateLoadingTemplate', true);
                let formData = new FormData();

                let body = {
                    "typeFile": this.modalUpload.type,
                    "subTypeFile": this.modalUpload.subType,
                }

                body = JSON.stringify(body);
                formData.append('request', body);
                formData.append('file', this.fileUpload);

                return UploadDocumentationFile(this.selectEntity, formData)
                .then(response => {


                    if(!this.isFileExist){
                        let nameSplit = response.data.result.file.split('/')
                        const file =
                            {
                                'type': nameSplit[6],
                                'subType': nameSplit[7],
                                'name': this.fileUpload.name,
                                'fileName': response.data.result.fileName,
                                'fileUrl' : response.data.result.file
                            }



                        this.tabsTitle.filter(el => {
                            if(el.type == file.type){
                                el.archives.filter(sub => {
                                    if(sub.type == file.subType){

                                        sub.files.push(
                                            {
                                                url: file.fileUrl,
                                                titleFile: file.name,
                                                type: file.type,
                                                subType: file.subType
                                            },
                                        );
                                    }
                                })
                            }
                        })
                    }



                    this.modalAlert.msg = this.$t('environmental-management.documentation.modal-alert-msg1')
                    this.modalAlert.show = true

                    this.closeModal();

                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);

                    if(error.response.data.errorMessage){
                        this.modalAlert.msg = error.response.data.errorMessage;
                        this.modalAlert.show = true
                    }

                    this.closeModal();
                    throw new Error('error to get GetDocumentationFiles values', error);
                })
                .finally(() => {
                    this.isFileExist = false;
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            getFiles(entityId){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                return GetDocumentationFiles(entityId)
                .then(response => {

                    this.files = [];
                    this.tabsTitle = _.cloneDeep(this.tabsTitleOriginal);
                    if(response.data.result.length > 0){
                        response.data.result.map(el => {
                            let nameSplit = el.fileName.split('/')
                            this.files.push(
                                {
                                    'type': nameSplit[2],
                                    'subType': nameSplit[3],
                                    'name': nameSplit[4],
                                    'fileName': el.fileName,
                                    'fileUrl' : el.fileUrl
                                }
                            )
                        })


                        this.files.map(file => {

                            this.tabsTitle.filter(el => {
                                if(el.type == file.type){
                                    el.archives.filter(sub => {
                                        if(sub.type == file.subType){
                                            sub.files.push(
                                                {
                                                    url: file.fileUrl,
                                                    titleFile: file.name,
                                                    type: file.type,
                                                    subType: file.subType
                                                },
                                            );
                                        }
                                    })
                                }
                            })
                        })
                    }

                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error to get GetDocumentationFiles values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            getDropdownEntities(){
                this.$store.commit('loadings/setStateLoadingTemplate', true);
                return GetDocumentationEntities(this.userState.entityParent)
                .then(response => {
                   this.entities = response.data;
                })
                .catch(error => {
                    this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error to get DropdownsEndPointGet values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },

            afterRemoveFile(type, subType, name){
                this.modalRemove.show = true
                this.modalRemove.type= type
                this.modalRemove.subType= subType
                this.modalRemove.name= name
            },
            removeFile(type, subType, name){
                this.modalRemove.show = false
                this.$store.commit('loadings/setStateLoadingTemplate', true);

                const body = {
                    "typeFile": type,
                    "subTypeFile": subType,
                    "nameFileDocument": name
                }

                return DeleteDocumentationFile(this.selectEntity, body)
                .then(response => {
                    this.tabsTitle.filter(el => {
                        if(el.type == type){
                            el.archives.filter(ar => {
                                if(ar.type == subType){
                                    const index = ar.files.findIndex(option => option.titleFile === name);

                                    ar.files.splice(index, 1)
                                }
                            })
                        }
                    })
                    this.modalAlert.msg = this.$t('environmental-management.documentation.modal-alert-msg3')
                    this.modalAlert.show = true;
                })
                .catch(error => {
                    //this.$requestStatus.checkRequestStatus(error.response.status, this.$route.name);
                    throw new Error('error to get DeleteDocumentationFile values', error);
                })
                .finally(() => {
                    this.$store.commit('loadings/setStateLoadingTemplate', false);
                })
            },
            loadUploadEmit(file){
                if(file){
                    this.fileUpload= file;
                }
            },
            closeModal(){
                this.fileUpload= null;
                this.modalUpload.show = false
                this.clearUpload = true;

                this.modalUpload.type= null
                this.modalUpload.subType= null

                this.modalDuplicate.show = false
            }
        },

        mounted(){
            this.selectEntity = this.userState.entityParent;
            this.getFiles(this.selectEntity);
            if(this.userState.isAdminSILiAmb){
                this.getDropdownEntities();
            }
        }
    }
</script>

<style lang="scss" scoped>

@import '@sass/_variables.scss';
    .select-entity{
        width: 400px;
    }
    .card-text-bg{
        position: relative;
    }

    ::v-deep .v-card .card-text-bg:nth-child(2n){
        background:$grey-light !important;

    }
    ::v-deep .v-tab{
        background: $grey-light;
        text-transform: initial;
        font-size: 18px;
        border-bottom: 2px solid #D6D6D6;
    }
    ::v-deep .v-tabs-slider{
        background: #ffffff;
    }
    ::v-deep .v-tab--active{
        background: #ffffff;
        color: var(--v-primary-base) !important;
    }
    ::v-deep .v-card__text {
        padding: 40px 45px 20px;
    }

    ::v-deep .v-slide-group__prev--disabled{
        @media (max-width: 1024px) {
            display: none !important;
        }
    }
    .img-remove{
        display: none;
        ::v-deep svg{
            path{
                fill: red !important;
            }
        }
    }
    .card-link-pdf{
        &:hover{
            .img-remove{
                display: inline-block;
            }
        }
    }
    .card-link-pdf a{
        color: black;
    }
    .button-upload{
        color: $grey;
        &:hover{
            color: var(--v-primary-base);
            ::v-deep svg{
                path{
                    fill: var(--v-primary-base) !important;
                }
            }
        }
    }

    .row-files{
        min-height: 20px;
        max-height: 125px;
        overflow-y: auto;
    }

    .title-card{
        @media (max-width: 500px) {
            text-align: center;
        }
    }
    .row-tabs{
        border-radius: 7px;
        overflow: hidden;
    }

    ::v-deep .v-tab:hover{
        background-color: #e6e0e0;
        color: var(--v-primary-base) !important;
    }
</style>
